import { DrawerClasses, SwipeableDrawer, useMediaQuery } from "@mui/material";
import { Dialog, DialogContent } from "@/components/ui/dialog";

function Drawer({
  children,
  isOpen,
  classes,
  closeDrawer,
  anchors = {
    large: "right",
    small: "bottom",
  },
  modalSize = "default", // new prop for modal sizing
}: {
  children: React.ReactNode;
  isOpen: boolean;
  classes?: Partial<DrawerClasses>;
  closeDrawer: () => void;
  anchors?: {
    large: "bottom" | "right";
    small: "bottom" | "right";
  };
  modalSize?: "default" | "large" | "small";
}) {
  const isDesktop = useMediaQuery("only screen and (min-width : 768px)");

  // Modal size classes
  const modalSizeClasses = {
    small: "max-w-md w-full max-h-[70vh] min-h-[30vh] h-auto",
    default: "max-w-lg w-full max-h-[85vh] min-h-[30vh] h-auto", 
    large: "max-w-4xl w-full max-h-[90vh] min-h-[50vh] h-auto",
  };

  if (isDesktop) {
    // Desktop: Centered modal
    return (
      <Dialog open={isOpen} onOpenChange={closeDrawer}>
        <DialogContent className={`${modalSizeClasses[modalSize]} p-0 gap-0 rounded-xl overflow-hidden !z-[110]`}>
          {/* Content */}
          <div className="h-full overflow-hidden">
            {children}
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  // Mobile: Swipeable drawer (existing behavior)
  return (
    <SwipeableDrawer
      disableDiscovery
      disableSwipeToOpen
      anchor={isDesktop ? anchors.large : anchors.small}
      open={isOpen}
      onClose={closeDrawer}
      onOpen={() => null}
      classes={classes}
      PaperProps={{
        style: {
          maxHeight: '85dvh',
          minHeight: '30dvh',
        }
      }}
    >
      <button
        type="button"
        onClick={closeDrawer}
        className="h-[32px] flex items-center justify-center mx-auto w-full absolute -top-8 left-1/2 -translate-x-1/2 z-10"
      >
        <div className="bg-primary-foreground rounded-full h-[6px] block w-[12.5%]" />
      </button>
      {children}
    </SwipeableDrawer>
  );
}

export { Drawer };
